module.exports = __webpack_public_path__ + "img/rooster.15aa6379.jpg";